import { render, staticRenderFns } from "./center.vue?vue&type=template&id=0e1b9499&scoped=true"
import script from "./center.vue?vue&type=script&lang=ts"
export * from "./center.vue?vue&type=script&lang=ts"
import style0 from "./center.vue?vue&type=style&index=0&id=0e1b9499&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1b9499",
  null
  
)

export default component.exports